import * as React from 'react'
import COLORS from '../../styles/colors'

interface IPropType {
  style?: object
  color?: string
}

const defaultSize = {
  height: 32,
  width: 32,
}
function Mic({ style, color = COLORS.primaryDark }: IPropType) {
  return (
    <svg style={{ ...defaultSize, ...style }} viewBox='0 0 32 32'>
      <defs>
        <style>{`.prefix__a{fill:${color}}`}</style>
      </defs>
      <path
        className='prefix__a'
        d='M31.36 5.227V4.181H10.453a1.047 1.047 0 00-1.045 1.046H7.317V3.659a3.659 3.659 0 10-7.317 0v9.408a3.659 3.659 0 007.317 0V6.272h2.091a1.047 1.047 0 001.045 1.045H31.36V6.272H13.067V5.227zM1.045 3.659a2.613 2.613 0 115.227 0v2.613H1.045zm5.227 9.408a2.613 2.613 0 01-5.227 0v-5.75h5.227zm5.749-6.795h-1.568V5.227h1.568zm0 0'
      />
      <path
        className='prefix__a'
        d='M2.091 12.544h1.045v1.045H2.091zm0 0M4.181 12.544h1.045v1.045H4.181zm0 0M2.091 10.453h1.045v1.045H2.091zm0 0M4.181 10.453h1.045v1.045H4.181zm0 0M2.091 8.363h1.045v1.045H2.091zm0 0M4.181 8.363h1.045v1.045H4.181zm0 0M28.224 9.931v19.861a.523.523 0 01-.523.523h-5.227a.523.523 0 01-.523-.523v-1.568a1.57 1.57 0 001.568-1.568v-2.093h.523a1.57 1.57 0 001.568-1.568v-4.181a1.047 1.047 0 001.045-1.045v-.523a8.885 8.885 0 00-17.771 0v.523a1.047 1.047 0 001.045 1.045v4.181a1.57 1.57 0 001.568 1.568h.523v2.091a1.57 1.57 0 001.568 1.568h1.045a1.57 1.57 0 001.568-1.568v-5.227a1.57 1.57 0 00-1.568-1.568h-1.048a1.57 1.57 0 00-1.568 1.568v2.091h-.523a.523.523 0 01-.523-.523v-4.181h.523a1.57 1.57 0 001.568-1.568 4.704 4.704 0 119.408 0 1.57 1.57 0 001.568 1.568h.523v4.181a.523.523 0 01-.523.523h-.523v-2.091a1.57 1.57 0 00-1.568-1.568h-1.045a1.57 1.57 0 00-1.568 1.568v5.227a1.57 1.57 0 001.568 1.568v1.568a1.57 1.57 0 001.572 1.573h5.227a1.57 1.57 0 001.568-1.568V9.931a.523.523 0 01.523-.523h1.568V8.363h-1.568a1.57 1.57 0 00-1.568 1.568zm-15.157 11.5a.523.523 0 01.523-.523h1.045a.523.523 0 01.523.523v5.227a.523.523 0 01-.523.523h-1.05a.523.523 0 01-.523-.523zM23.52 17.25a5.75 5.75 0 00-11.5 0 .523.523 0 01-.523.523H9.929v-.523a7.84 7.84 0 0115.68 0v.523h-1.568a.523.523 0 01-.521-.525zm-3.136 9.408v-5.227a.523.523 0 01.523-.523h1.045a.523.523 0 01.523.523v5.227a.523.523 0 01-.523.523h-1.045a.523.523 0 01-.522-.525zm0 0'
      />
    </svg>
  )
}

export default Mic
